define("shared/components/shared/profile-categorization/loading", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--blank">
    <Shared::LoadingSpinner @additionalClass="u--p__b__lg qa--categorize_reports_loading" />
    <h2 class="o--blank__title u--p__t__lg">
      {{t "shared_words.loading"}}
    </h2>
  </div>
  */
  {
    "id": "PPf8lvER",
    "block": "[[[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@additionalClass\"],[\"u--p__b__lg qa--categorize_reports_loading\"]],null],[1,\"\\n  \"],[10,\"h2\"],[14,0,\"o--blank__title u--p__t__lg\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"shared_words.loading\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[],false,[\"shared/loading-spinner\",\"t\"]]",
    "moduleName": "shared/components/shared/profile-categorization/loading.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});